import { passwordConfirmationSchema, PasswordSchema, UsernameSchema } from '@vy/types';
import { oz } from '@vy/utils';

export const RegisterFormInputSchema = oz.object({
  username: UsernameSchema.optional(),
  password: PasswordSchema.optional(),
  confirmPassword: passwordConfirmationSchema.optional(),
});

export type RegisterFormInput = oz.infer<typeof RegisterFormInputSchema>;
